var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.subtitle && _vm.narration.id)?_c('Subtitles',{key:_vm.narration.id,attrs:{"subtitles":_vm.chapter.audio.subtitles[_vm.narration.name],"name":_vm.narration.name}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }